export default "__VITE_ASSET__BOZuRytb__"